var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[(!_vm.hamburguerMenu)?_c('el-aside',{attrs:{"id":"leftNavBar"}},[_c('LeftNavBar')],1):_vm._e(),_c('el-main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.hiddenFooter)?_c('el-footer',{attrs:{"id":"footer"}},[_c('Footer')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }